import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConsoleService {

  constructor() { }

  // log(pre: string, msg?: string): any {
  //   if (msg === undefined) {
  //     return function (msg: string) {
  //       console.log(`[${pre}] ${msg}`)
  //     }
  //   } else {
  //     console.log(`[${pre}] ${msg}`)
  //   }
  // }

  log(pre?: string, ...optionalParams: any): any {
    if (optionalParams === undefined || optionalParams.length === 0) {
      return function (...optionalParams: any) {
        if (pre !== undefined)
          console.log(`[${pre}]`, ...optionalParams)
        else
          console.log(...optionalParams)
      }
    } else {
      if (pre !== undefined)
        console.log(`[${pre}]`, ...optionalParams)
      else
        console.log(...optionalParams)
    }
  }

  // private printLog(pre?: string, ...optionalParams: any) {
  //   if (pre !== undefined)
  //     console.log(`[${pre}]`, optionalParams)
  //   else
  //     console.log(optionalParams)
  // }
}
